module.exports = __webpack_public_path__ + "static/media/youtube-brands.fd99f0f2.svg";